import isNumber from "./isNumber";

const isValidPrice = price => {
  if (!isNumber(price)) return false;

  return Number(price) >= 0;
};

export default isValidPrice;
